import React, { Component, Fragment } from "react";

export default class Select extends Component {

    constructor(props) {
        super(props);

        this.state = {
            linhas: [
                ["Todas", "Todas"],
                ["Consultoria em Tecnologia", "Consultoria em Tecnologia"],
                ["Serviços Técnicos Especializados", "Serviços Técnicos Especializados"],
                ["Pesquisa, Desenvolvimento e Inovação", "Pesquisa, Desenvolvimento e Inovação"],
                ["Metrologia", "Metrologia"],
                ["Serviços Complementares", "Serviços Complementares"],
            ],
            categorias: [
                ["Consultoria em Processos Produtivos", "Consultoria em Processos Produtivos"],
                ["Consultoria para Atendimento de Legislações, Normas e Regulamentos Técnicos", "Consultoria para Atendimento de Legislações, Normas e Regulamentos Técnicos"],
                ["Serviços Operacionais", "Serviços Operacionais"],
                ["Pesquisa, Desenvolvimento e Inovação de Processos", "Pesquisa, Desenvolvimento e Inovação de Processos"],
                ["Pesquisa, Desenvolvimento e Inovação de Produto", "Pesquisa, Desenvolvimento e Inovação de Produto"],
                ["Calibração", "Calibração"],
                ["Ensaios", "Ensaios"],
                ["Consultoria em Gestão Empresarial", "Consultoria em Gestão Empresarial"],
            ],
            unidades: [
                ["Todas", "Todas"],
                // ["Instituto SENAI de Tecnologia em Automação (ISTAI)", "ISTAI"],
                ["Instituto SENAI de Tecnologia Têxtil e Confecções (ISTTC)", "ISTTC"],
                ["IST Eficiência Operacional (ISTEO)", "ISTEO"]
            ]
        }

    }

    render() {
        let { select, option, atributo, exibeTodas } = this.props;
        return (
            <Fragment>
                    <form>
                        <div className="form-group">
                            <label style={{ textTransform: "capitalize"}}>{option}: </label>
                            <select onChange={select} className="form-control" name={atributo}>
                                {(this.state[option] || this.state["unidades"]).map((option, i) => {
                                    // if(exibeTodas && i === 0) return;
                                    return(
                                        <option value={option[1]} key={option[0]}>{option[0]}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </form>
            </Fragment>
        )
    }
}